export default "__VITE_ASSET__2db0c720__"